import { sourcesData} from '../data/symtomsData'
import { Card, Text, Title, Anchor } from '@mantine/core';


const SourcesCard = () => {
  return (
    <Card shadow="md" p="xl" radius="lg" withBorder className="modern-card">
      <Title order={3} mb="lg" c="gray.1">
        📊 {sourcesData.title}
      </Title>
      
      <div className="space-y-4">
        {sourcesData.sources.map((source, index) => (
          <div key={index}>
            <Anchor 
              href={source.url} 
              target="_blank" 
              rel="noopener noreferrer"
              c="blue.4"
              fw={500}
              size="sm"
            >
              {source.name} ↗
            </Anchor>
            <Text c="gray.3" size="xs" mt="xs">
              {source.description}
            </Text>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default SourcesCard;